<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-user-shield"></i></div>
      <div>
        Rôles et permissions
        <div class="page-title-subheading">Droits accordés à chaque rôle, regroupés par fonctionnalité</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<p class="text-muted small mb-3">
  {{data.length}} rôle(s). Dépliez un rôle pour consulter et modifier ses droits.
</p>

<div class="accordion" id="rolesAccordion">
  <div class="accordion-item" *ngFor="let r of data; let i = index">

    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button"
              data-bs-toggle="collapse" [attr.data-bs-target]="'#role-' + r.id"
              [attr.aria-controls]="'role-' + r.id" aria-expanded="false">
        <span class="fw-semibold me-3">{{roleLabel(r.name)}}</span>
        <span class="badge bg-danger me-2">{{countPermissions(r)}} droits</span>
        <span class="badge bg-light text-dark border">{{countFeatures(r)}} fonctionnalités</span>
      </button>
    </h2>

    <div [id]="'role-' + r.id" class="accordion-collapse collapse" data-bs-parent="#rolesAccordion">
      <div class="accordion-body">

        <div class="d-flex flex-column flex-md-row align-items-md-center gap-2 mb-3">
          <div class="form-group" style="min-width: 260px;">
            <input type="text" class="form-control form-control-sm"
                   placeholder="Filtrer les fonctionnalités..."
                   [ngModel]="searchFor(r)" (ngModelChange)="setSearch(r, $event)"
                   [name]="'search_' + r.id">
          </div>
          <div class="d-flex gap-2 ms-md-auto">
            <button class="btn btn-outline-secondary btn-sm" (click)="open(dialog2,r)">
              <i class="fa-solid fa-copy me-1" aria-hidden="true"></i>Copier vers
            </button>
            <button class="btn btn-danger btn-sm" (click)="open(dialog,r)">
              <i class="fa-solid fa-plus me-1" aria-hidden="true"></i>Ajouter un droit
            </button>
          </div>
        </div>

        <div class="alert alert-light border mb-0" *ngIf="countPermissions(r)===0">
          Aucun droit accordé à ce rôle.
        </div>

        <div style="max-height: 45vh; overflow-y: auto;">
          <div class="mb-3" *ngFor="let g of groupByFeature(r.permissions, searchFor(r))">
            <div class="fw-semibold small text-uppercase text-muted mb-2">{{g.label}}</div>
            <div class="d-flex flex-wrap gap-2">
              <span class="badge bg-light text-dark border d-inline-flex align-items-center"
                    *ngFor="let p of g.items">
                {{p.action}}
                <button type="button" class="btn-close ms-2" style="font-size: .55rem;"
                        aria-label="Retirer" title="Retirer ce droit"
                        (click)="revoke(r.id, p.id)"></button>
              </span>
            </div>
          </div>

          <div class="text-muted small"
               *ngIf="countPermissions(r)>0 && groupByFeature(r.permissions, searchFor(r)).length===0">
            Aucune fonctionnalité ne correspond à ce filtre.
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<ng-template #dialog  let-ref="dialogRef" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value,ref)">
      <div class="modal-header">
            <h6 class="modal-title">
              Ajout de droit</h6>
              <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>

            
      </div>
      <div class="modal-body">
          <div class="form-group">
            <label for="">Permission</label>
            <ng-select name="permissions" ngModel [multiple]="true" >
              <ng-container *ngFor="let f of features">
                <span>{{f.name}}</span>
                <ng-option *ngFor="let p of f.permissions" [value]="p.id">{{p.name}}</ng-option>
              </ng-container>
            </ng-select>
          </div>
               
      
          <div>
            <button type="submit" class="btn btn-outline-primary" [disabled]="addForm.invalid || loading">Sauvegarder <app-loading [isVisible]="loading"></app-loading> </button>
          </div>
        
        </div>
</form>
  </ng-template>

  <ng-template #dialog2  let-ref="dialogRef" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="copyStore(addForm.value,ref)">
      <div class="modal-header">
            <h6 class="modal-title">
              Copie de droit vers </h6>
              <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>

            
      </div>
      <div class="modal-body">
          <div class="form-group">
            <label for="">Rôle</label>
            <ng-select name="role_id" ngModel >
                <ng-option *ngFor="let r of data" [value]="r.id">{{r.name}}</ng-option>
            </ng-select>
          </div>
               
      
          <div>
            <button type="submit" class="btn btn-outline-primary" [disabled]="addForm.invalid || loading">Sauvegarder <app-loading [isVisible]="loading"></app-loading> </button>
          </div>
        
        </div>
</form>
  </ng-template>